/**
 * REGISTRE CENTRAL DES CONTEXTES IA — Singleton
 * Chaque module s'enregistre via un fichier .aicontext.js.
 */
class AIContextRegistry {
  constructor() {
    this.contexts = new Map();
    this.tokenMap = new Map();
  }

  register({ id, label, description, icon, tokens, parameterized = false, parameterSeparator = ':', examples = [], defaultEnabled = true, ...rest }) {
    if (!id || !tokens?.length) {
      console.error('[AIContextRegistry] Config invalide pour "' + id + '"');
      return;
    }
    this.contexts.set(id, { id, label, description, icon, tokens, parameterized, parameterSeparator, examples, defaultEnabled, ...rest });
    tokens.forEach((t) => this.tokenMap.set(t.replace('$', '').toLowerCase(), id));
  }

  detectTokens(message) {
    const regex = /\$([a-zA-Z]+)(?::([^\s]+))?/g;
    const detected = [];
    let match;
    while ((match = regex.exec(message)) !== null) {
      const contextId = this.tokenMap.get(match[1].toLowerCase());
      if (contextId) {
        const ctx = this.contexts.get(contextId);
        detected.push({ fullMatch: match[0], token: '$' + match[1], parameter: match[2] || null, contextId, label: ctx.label, icon: ctx.icon });
      }
    }
    return detected;
  }

  getSuggestions(prefix = '', availableSymbols = []) {
    const results = [];
    this.contexts.forEach((ctx) => {
      ctx.tokens.forEach((token) => {
        const name = token.replace('$', '');
        if (name.toLowerCase().startsWith(prefix.toLowerCase())) {
          const subSuggestions = ctx.parameterized
            ? availableSymbols.map((s) => {
                const symbol = typeof s === 'object' && s && 'symbol' in s ? s.symbol : s;
                const displayName = typeof s === 'object' && s && ('name' in s || 'nom' in s) ? (s.name || s.nom || s.symbol) : s;
                return { token: token + ctx.parameterSeparator + symbol, label: displayName, symbol };
              })
            : [];
          results.push({
            token,
            label: ctx.label,
            description: ctx.description,
            icon: ctx.icon,
            parameterized: ctx.parameterized,
            parameterSeparator: ctx.parameterSeparator,
            subSuggestions,
          });
        }
      });
    });
    return results;
  }

  getAllContexts() {
    return Array.from(this.contexts.values());
  }
}

export const aiContextRegistry = new AIContextRegistry();
export default aiContextRegistry;
